import { useEffect, useContext } from 'react';
import { ValidatorContext } from 'Validation/ValidatorContext';

/**
 * Registers a validator function for a given step in the validator context.
 * 
 * @param {string} stepName - The key for the input step (e.g., 'location').
 * @param {string} inputName - The key for the input (e.g., 'postcode').
 * @param {Function} validatorFn - The function that returns true if valid.
 */
export const useStepValidator = (stepName, inputName, validatorFn) => {
  const { registerInputValidator } = useContext(ValidatorContext);

  useEffect(() => {
    registerInputValidator(stepName, inputName, validatorFn);
  }, [stepName, inputName, validatorFn, registerInputValidator]);
};
